module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor-url"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon icon-compass2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editor_url.editor_animation_url),
      expression: "editor_url.editor_animation_url"
    }],
    attrs: {
      "type": "text",
      "placeholder": "动画编辑器URL"
    },
    domProps: {
      "value": (_vm.editor_url.editor_animation_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editor_url, "editor_animation_url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon icon-compass2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editor_url.timeline_url),
      expression: "editor_url.timeline_url"
    }],
    attrs: {
      "type": "text",
      "placeholder": "时间轴URL"
    },
    domProps: {
      "value": (_vm.editor_url.timeline_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editor_url, "timeline_url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon icon-compass2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editor_url.psocket_url),
      expression: "editor_url.psocket_url"
    }],
    attrs: {
      "type": "text",
      "placeholder": "PSocketUrl"
    },
    domProps: {
      "value": (_vm.editor_url.psocket_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editor_url, "psocket_url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "btn-save",
    on: {
      "click": _vm.saveUrl
    }
  }, [_vm._v("保存")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a746a73a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditorUrl/EditorUrl.vue
// module id = 403
// module chunks = 0